import { Card, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { IoPerson, IoKey, IoNotifications, IoCard, IoInformationCircle } from "react-icons/io5";

const menuItems = [
  { id: 0, name: "Perfil", icon: <IoPerson /> },
  { id: 1, name: "Pixel", icon: <IoInformationCircle /> },
  { id: 2, name: "Mudar Senha", icon: <IoKey /> },
  { id: 3, name: "Notificações", icon: <IoNotifications /> },
  { id: 4, name: "Assinatura", icon: <IoCard /> },
];

function SideMenu({ selectedItem, onItemClick }) {
  return (
    <Card>
      <VuiBox p={2}>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                onClick={() => onItemClick(item.id)}
                sx={{
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#2D3748",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: "36px", color: "#fff" }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.name}
                  primaryTypographyProps={{
                    sx: {
                      color: "#fff",
                      fontFamily: '"Plus Jakarta Display", "Helvetica", "Arial", sans-serif',
                      fontWeight: 400,
                      fontSize: "14px", // Tamanho de fonte reduzido...
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </VuiBox>
    </Card>
  );
}

export default SideMenu;